<template>
  <v-dialog :value="value" max-width="500" @input="$emit('input', $event)">
    <div>
      <div class="basic-info-popup">
        <strong class="basic-info-popup__title">기본정보 변경</strong>

        <div class="basic-info-popup__field">
          <label>연락처(본인)</label>
          <input
            v-model.trim="form.mobile"
            type="text"
            maxlength="13"
            :readonly="!isCorporate"
          />
          <p v-if="!isCorporate" class="basic-info-popup__helper">
            본인인증 시 확인된 휴대폰번호입니다.
          </p>
        </div>

        <div class="basic-info-popup__field">
          <label>연락처(기타)</label>
          <input v-model.trim="form.telephone" type="text" maxlength="13" />
        </div>

        <div class="basic-info-popup__field">
          <label>이메일 <span v-if="editEmail">(변경)</span></label>
          <div class="one-line"> 
            <input v-model.trim="form.email" type="email" maxlength="100" readonly v-if="!editEmail" />
            <input v-model.trim="newEmail" type="email" maxlength="100" :disabled="showEmailCode" v-else />
            <v-btn color="primary" class="ml-2 mr-2" elevation="0" @click="editEmail = !editEmail" v-if="!editEmail">변경하기</v-btn>
            <v-btn color="primary" class="ml-2 mr-2" elevation="0" style="font-size: 12px;" @click="sendEmailCode()" v-else>인증번호 발송</v-btn>
          </div>
          <div class="basic-info-popup__field" v-if="editEmail&& showEmailCode">
            <label>인증번호</label>
            <input v-model.trim="editEmailCode" type="text" maxlength="4"  />
          </div>
      </div>

        <div class="basic-info-popup__field">
          <label>우편물 수령주소</label>
          <div class="basic-info-popup__address-row">
            <input
              v-model.trim="form.zipcode"
              type="text"
              maxlength="10"
              class="is-zip"
              readonly
            />
            <button
              type="button"
              class="address-search-button"
              @click="openPostcodeDialog"
            >
              우편번호 찾기
            </button>
          </div>
          <input
            :value="form.address1 + ' ' + addressExtra"
            style="margin-bottom:4px;"
            type="text"
            maxlength="120"
            readonly
          />
          <input
            v-model.trim="form.address2"
            style="margin-bottom:4px;"
            type="text"
            maxlength="120"
            placeholder="상세주소"
          />
          <!-- <input
            v-model.trim="form.addressExtra"
            type="text"
            maxlength="120"
            placeholder="참고항목"
            readonly
          /> -->
        </div>
        <!-- 약관 동의 체크박스 -->
        <div class="basic-info-popup__field one-line" @click="agreeDialog = !agreeDialog" >
        <v-checkbox v-model="agreeCheck" readonly label="" class="mr-0 pa-0"/> <span 
             class="agree-check-text mb-1">유의사항 확인 및 동의 (필수)</span>

          <v-dialog v-model="agreeDialog" max-width="460" content-class="postcode-dialog">
            <div class="postcode-embed-popup">
              <div class="postcode-embed-popup__header">
                <strong> ※ 기본정보 변경 유의사항(연락처, 이메일, 우편물 수령주소)</strong>
              </div>
              <div class="pa-4" v-html="agreeText" style="text-align: left; font-size: 13px; font-weight: 400; line-height: 1.6;">
              </div>

              <v-divider></v-divider>

              <div class="d-flex justify-end">
                <v-btn color="grey" class="mr-2" text @click="agreeCheck = false; agreeDialog = false;">닫 기</v-btn>
                <v-btn color="primary" class="ml-2 mr-2" text @click="agreeCheck = true; agreeDialog = false;">동의합니다</v-btn>
              </div>
            </div>
          </v-dialog>

        </div>
        <p class="basic-info-popup__notice">
          ※ 요청하신 기본 정보 변경은 즉시 반영 됩니다. 신중하게 수정 하시기 바랍니다.
        </p>
        <div class="basic-info-popup__footer">
          <button
            type="button"
            class="basic-info-popup__button is-close"
            @click="goBack"
          >
            뒤로가기
          </button>
          <button
            type="button"
            class="basic-info-popup__button is-submit"
            :disabled="!isFormReady || loading"
            @click="submit"
          >
            변경
          </button>
        </div>
      </div>

      <v-dialog v-model="postcodeDialog" max-width="460" content-class="postcode-dialog">
        <div class="postcode-embed-popup">
          <div class="postcode-embed-popup__header">
            <strong>우편번호 찾기</strong>
            <button
              type="button"
              class="postcode-embed-popup__close"
              @click="closePostcodeDialog"
            >
              닫기
            </button>
          </div>
          <div ref="postcodeContainer" class="postcode-embed-popup__body"></div>
        </div>
      </v-dialog>

      <div v-if="loading" class="basic-info-loading-layer">
        <div class="basic-info-loading-dialog">
          <v-progress-circular indeterminate color="#ef761d" size="28"></v-progress-circular>
          <p>변경 중입니다...</p>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>

export default {
  // 계약자의 연락처, 이메일, 주소를 즉시 변경하는 입력 다이얼로그
  name: "ContractorBasicInfoChangeDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    contractorInfo: {
      type: Object,
      default: () => ({}),
    },
    user: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      role: "",
      originalForm: {
        mobile: "",
        telephone: "",
        email: "",
        zipcode: "",
        address1: "",
        address2: ""
      },
      form: {
        mobile: "",
        telephone: "",
        email: "",
        zipcode: "",
        address1: "",
        address2: "",
      },
      addressExtra: "",
      postcodeDialog: false,
      agreeCheck: false,

      agreeDialog: false,
      agreeText: `• 회원 정보와 계약자 정보(성명/ 연락처) 불일치 시 계약단지 조회가 불가합니다. 변경 시 신중히 진행해 주시기 바랍니다.<br>
• 휴대폰 번호는 본인 명의로만 변경 가능합니다. 공동 명의 계약은 각자 변경해야 합니다.<br>
• 연락처, 이메일, 우편물 수령주소는 변경 즉시 당사 연관 시스템에 실시간 반영됩니다.<br>
• 이메일은 형식에 맞게 입력해야 하며, 인증(인증번호 또는 확인 링크) 완료 후 저장됩니다.<br>
• 변경되거나 등록된 주소는 계약 관련 주요 공지 및 알림(옵션변경, 대출신청, 공정확인, 설계 변경, 사전점검 초청장, 입주 안내문 등) 우편물 발송에 사용됩니다.<br>
• 이미 접수된 업무는 기존 연락처, 이메일 및 우편물 수령주소로 안내될 수 있습니다.<br>
• 오기재, 이사통지 지연, 수취인 부재 등으로 인한 안내 미수신∙지연의 책임은 계약자에게 있습니다.<br>
• 공동주택은 동∙호수 누락 시 우편 미도착∙반송이 발생할 수 있습니다.<br>
• 타인의 정보를 도용할 경우 법적 책임이 발생할 수 있습니다.`,

      editEmail: false,
      newEmail: "",
      editEmailCode: "",
      showEmailCode: false,
      latestSendAt: null,
    };
  },
  computed: {
    home() {
      return this.$store.getters.getHome;
    },
    isFormReady() {
      return this.form.mobile && this.form.address1 && this.agreeCheck;
    },
    isCorporate() {
      return !!this.contractorInfo.is_corporate;
    },
  },
  watch: {
    value(val) {
      if (val) {
        // 다이얼로그를 열 때마다 최신 계약자 정보를 기준으로 폼을 다시 구성한다.
        this.init()
        this.getContractorUpdateInfo();
      } else {
        this.closePostcodeDialog();
      }
    },
  },
  methods: {
    init() {
      this.editEmail = false;
      this.newEmail = "";
      this.editEmailCode = "";
      this.showEmailCode = false;
      this.latestSendAt = null;
    },
    getContractorUpdateInfo() {
      this.initForm(this.contractorInfo || {});
    },

    initForm(contractorInfo) {
      // 주소 필드를 우편번호/기본주소/상세주소/참고항목으로 다시 분리해 폼에 맞춘다.
      const mappedForm = {
        telephone: contractorInfo.tel || "",
        email:
          contractorInfo.email || "",
        zipcode:
          contractorInfo.post_code || "",
        address1: contractorInfo.address1,
        address2: contractorInfo.address2,
      };
      this.addressExtra = ""

      this.role = contractorInfo.role || "";
      this.originalForm = { ...mappedForm, mobile: contractorInfo.mobile || "" };
      this.form = {
        ...mappedForm,
        mobile: this.isCorporate
          ? contractorInfo.mobile || ""
          : this.user.mobile || "",
      };
    },
    normalizeValue(value) {
      return String(value ?? "").trim();
    },
    normalizePhone(value) {
      return this.normalizeValue(value).replace(/\D/g, "");
    },
    buildAddress2(detailValue, extraValue) {
      const detail = this.normalizeValue(detailValue);
      const extra = this.normalizeValue(extraValue);

      if (detail && extra) {
        return `${detail} ${extra}`;
      }

      return detail || extra;
    },
    // parseAddressFields(address1, address2) {
    //   const address1 = this.normalizeValue(address1);
    //   const address2 = this.normalizeValue(address2);

    //   const extraPattern = /\([^)]+\)/;

    //   let address1 = normalizedAddress1;
    //   let address2 = normalizedAddress2;
    //   let addressExtra = "";

    //   const address1ExtraMatch = normalizedAddress1.match(extraPattern);
    //   const address2ExtraMatch = normalizedAddress2.match(extraPattern);

    //   if (address1ExtraMatch) {
    //     addressExtra = address1ExtraMatch[0];
    //     address1 = normalizedAddress1.replace(extraPattern, "").trim();
    //   } else if (address2ExtraMatch) {
    //     addressExtra = address2ExtraMatch[0];
    //     address2 = normalizedAddress2.replace(extraPattern, "").trim();
    //   }

    //   if (address2 && addressExtra) {
    //     address2 = address2 + " " + addressExtra;
    //   }

    //   return {
    //     address1,
    //     address2,
    //   };
    // },
    // 변경된 필드만 골라 API payload를 구성한다.
    getChangedPayload() {
      const payload = {};

      if (
        this.normalizePhone(this.form.mobile) !==
        this.normalizePhone(this.originalForm.mobile)
      ) {
        payload.mobile = this.normalizePhone(this.form.mobile);
      }

      if (
        this.normalizePhone(this.form.telephone) !==
        this.normalizePhone(this.originalForm.telephone)
      ) {
        payload.tel = this.normalizePhone(this.form.telephone);
      }

      if (
        this.normalizeValue(this.form.email) !==
        this.normalizeValue(this.originalForm.email)
      ) {
        payload.email = this.normalizeValue(this.form.email);
        if (this.showEmailCode && this.editEmailCode) {
          payload.email_verification_code = this.editEmailCode;
        } else {
          payload.email_verification_code = null;
        }
      }

      if (
        this.normalizeValue(this.form.zipcode) !==
        this.normalizeValue(this.originalForm.zipcode)
      ) {
        payload.post_code = this.normalizeValue(this.form.zipcode);
      }

      if (
        this.normalizeValue(this.form.address1) !==
        this.normalizeValue(this.originalForm.address1)
      ) {
        payload.address1 = this.normalizeValue(this.form.address1);
      }
      console.log(this.buildAddress2(
        this.form.address2,
        this.addressExtra
      ) ,this.normalizeValue(this.originalForm.address2))
      if (
        this.buildAddress2(
          this.form.address2,
          this.addressExtra
        ) !==
        this.normalizeValue(this.originalForm.address2)
      ) {
        payload.address2 = this.buildAddress2(
          this.form.address2,
          this.addressExtra
        );
      }

      return payload;
    },
    close() {
      this.closePostcodeDialog();
      this.$emit("input", false);
    },
    goBack() {
      this.closePostcodeDialog();
      this.$emit("back");
    },
    submit() {
      const changedPayload = this.getChangedPayload();

      if (this.editEmail && (!this.newEmail || !this.showEmailCode)) {
        this.$store.commit("ERROR", "변경할 이메일 입력 및 이메일 인증을 완료해주세요.");
        return;
      }

      if (!Object.keys(changedPayload).length) {
        this.$store.commit("ERROR", "변경된 정보가 없습니다.");
        return;
      }

      if (this.showEmailCode && (!this.editEmailCode || this.editEmailCode.length !== 4)) {
        this.$store.commit("ERROR", "인증번호를 4자리 숫자로 입력해주세요.");
        return;
      } 

      this.$emit("submit", changedPayload);
    },
    loadPostcodeScript() {
      // 우편번호 검색은 필요한 시점에만 스크립트를 로드한다.
      if (window.kakao && window.kakao.Postcode) {
        return Promise.resolve();
      }

      const existingScript = document.getElementById("kakao-postcode-script");
      if (existingScript) {
        return new Promise((resolve, reject) => {
          existingScript.addEventListener("load", resolve, { once: true });
          existingScript.addEventListener(
            "error",
            () => reject(new Error("Kakao postcode script load failed")),
            { once: true }
          );
        });
      }

      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.id = "kakao-postcode-script";
        script.src =
          "//t1.kakaocdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";
        script.onload = resolve;
        script.onerror = () =>
          reject(new Error("Kakao postcode script load failed"));
        document.body.appendChild(script);
      });
    },
    buildExtraAddress(data) {
      let extraAddr = "";

      if (data.bname !== "" && /[동로가]$/.test(data.bname)) {
        extraAddr += data.bname;
      }

      if (data.buildingName !== "" && data.apartment === "Y") {
        extraAddr +=
          extraAddr !== ""
            ? `, ${data.buildingName}`
            : data.buildingName;
      }

      return extraAddr !== "" ? `(${extraAddr})` : "";
    },
    closePostcodeDialog() {
      this.postcodeDialog = false;
    },
    openPostcodeDialog() {
      // 현재 입력 흐름을 유지하기 위해 주소 검색을 내부 다이얼로그로 연다.
      this.loadPostcodeScript()
        .then(() => {
          this.postcodeDialog = true;
          this.$nextTick(() => {
            this.embedPostcode();
          });
        })
        .catch(() => {
          this.$store.commit(
            "ERROR",
            "우편번호 서비스를 불러오지 못했습니다. 잠시 후 다시 시도해주세요."
          );
        });
    },
    embedPostcode() {
      const container = this.$refs.postcodeContainer;

      if (!container) return;

      container.innerHTML = "";

      // 선택된 주소를 폼 구조에 맞게 분리해 즉시 반영한다.
      new window.kakao.Postcode({
        oncomplete: (data) => {
          const address =
            data.userSelectedType === "R"
              ? data.roadAddress
              : data.jibunAddress;

          this.form.zipcode = data.zonecode || "";
          this.form.address1 = address || "";
          this.form.address2 = "";
          this.addressExtra = data.userSelectedType === "R" ? this.buildExtraAddress(data) : "";
            
          this.closePostcodeDialog();
        },
        width: "100%",
        height: "100%",
      }).embed(container);
    },
    sendEmailCode() {

      // 새로운 이메일 포맷 체크 (이메일 형식이 맞는지 체크)
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.newEmail)) {
        this.$store.commit("ERROR", "이메일 형식이 맞지 않습니다.");
        return;
      }

      if (this.newEmail === this.originalForm.email) {
        this.$store.commit("ERROR", "기존 이메일과 동일합니다.");
        return;
      }

      // 5초 이내 번호 발송 방지
      if (this.latestSendAt && new Date() - this.latestSendAt < 5000) {
        this.$store.commit("ERROR", "인증번호 발송중입니다. 잠시 후 다시 시도해주세요.");
        return;
      }

      // 번호 발송
      this.form.email = this.newEmail;
      this.latestSendAt = new Date();
      this.showEmailCode = true
      this.$emit("sendEmailCode", this.newEmail);
    },
  },
  created() {
    this.init()
    this.getContractorUpdateInfo();
  },
  
};
</script>

<style scoped>
.basic-info-popup {
  border-radius: 20px;
  background-color: #ffffff;
  padding: 26px 24px 22px;
  text-align: left;
}

.basic-info-popup__title {
  display: block;
  margin-bottom: 24px;
  text-align: center;
  color: #ef761d;
  font-size: 24px;
  font-weight: 700;
}

.basic-info-popup__field {
  margin-bottom: 16px;
  text-align: left;
}

.basic-info-popup__field label {
  display: block;
  margin-bottom: 8px;
  color: #b8b8b8;
  font-size: 14px;
  font-weight: 700;
}

.basic-info-popup__field input {
  width: 100%;
  height: 40px;
  border: 1px solid #252525;
  padding: 0 10px;
  font-size: 14px;
  color: #232323;
  text-align: left;
  box-sizing: border-box;
  border-radius: 6px;
}

.basic-info-popup__address-row {
  display: flex;
  gap: 4px;
  margin-bottom: 4px;
}

.basic-info-popup__address-row:last-child {
  margin-bottom: 0;
}

.basic-info-popup__address-row .is-zip {
  flex: 0 0 110px;
}

.address-search-button {
  flex: 0 0 118px;
  height: 40px;
  border: 0;
  background-color: #101010;
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  border-radius: 6px;
}

.basic-info-popup__notice {
  margin: 10px 0 22px;
  color: #ef761d;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.4;
  word-break: keep-all;
}

.basic-info-popup__footer {
  display: flex;
  gap: 6px;
}

.basic-info-popup__button {
  height: 48px;
  border: 0;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 700;
}

.basic-info-popup__button.is-close {
  flex: 0 0 110px;
  background-color: #d9d9d9;
  color: #232323;
}

.basic-info-popup__button.is-submit {
  flex: 1 1 auto;
  background-color: #ef761d;
  color: #ffffff;
}

.basic-info-popup__button.is-submit:disabled {
  opacity: 0.45;
}

.postcode-embed-popup {
  overflow: hidden;
  border-radius: 18px;
  background-color: #ffffff;
}

.postcode-embed-popup__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #ececec;
}

.postcode-embed-popup__header strong {
  color: #232323;
  font-size: 16px;
  font-weight: 700;
}

.postcode-embed-popup__close {
  border: 0;
  background: transparent;
  color: #666666;
  font-size: 14px;
  font-weight: 700;
}

.postcode-embed-popup__body {
  width: 100%;
  height: 420px;
}

.basic-info-loading-layer {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 5px 5px 15px rgba(0,0,0,0.25);
}

.basic-info-loading-dialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 28px 20px;
  border-radius: 18px;
  background-color: #ffffff;
}

.basic-info-loading-dialog p {
  margin: 0;
  color: #444444;
  font-size: 14px;
  font-weight: 700;
}

@media (max-width: 359px) {
  .basic-info-popup {
    padding: 22px 18px 18px;
  }

  .basic-info-popup__address-row {
    flex-direction: column;
  }

  .basic-info-popup__address-row .is-zip,
  .address-search-button {
    flex: 1 1 auto;
  }
}

.basic-info-popup__helper {
  margin: 8px 0 0;
  color: #767676;
  font-size: 13px;
  line-height: 1.45;
  word-break: keep-all;
}

.one-line {
  display: flex;
  align-items: center;
  gap: 0px;
  cursor: pointer;
}
.agree-check-text {
  font-size: 14px;
  text-decoration: underline;
  text-align: center;
}
</style>
